import React, { useEffect, useRef, useState } from 'react';

const BAR_COLORS = {
  communication: 'var(--green)',
  difficulty: 'var(--orange)',
  fairness: 'var(--blue)',
};

export default function MiniRatings({ ratings }) {
  const [animated, setAnimated] = useState(false);
  const ref = useRef();

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setAnimated(true); },
      { threshold: 0.3 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <div ref={ref} style={{ display: 'flex', gap: 16, marginBottom: 14, flexWrap: 'wrap' }}>
      {Object.entries(ratings).map(([key, val]) => (
        <div key={key} style={{ display: 'flex', alignItems: 'center', gap: 8, minWidth: 130, flex: 1 }}>
          <div style={{ fontSize: 10, color: 'var(--text3)', textTransform: 'capitalize', fontWeight: 600, whiteSpace: 'nowrap', width: 80, flexShrink: 0, fontFamily: 'var(--google-sans)' }}>
            {key}
          </div>
          <div style={{ flex: 1, height: 4, background: 'var(--surface2)', borderRadius: 2, overflow: 'hidden' }}>
            <div style={{
              height: '100%', borderRadius: 2,
              background: BAR_COLORS[key] || 'var(--blue)',
              width: animated ? `${(Math.round(val) / 5) * 100}%` : '0%',
              transition: 'width 1s cubic-bezier(0.16,1,0.3,1)',
            }} />
          </div>
          <div style={{ fontFamily: 'var(--mono)', fontSize: 11, color: 'var(--text2)', fontWeight: 600, width: 28, textAlign: 'right', flexShrink: 0 }}>
            {Math.round(val)}/5
          </div>
        </div>
      ))}
    </div>
  );
}
